(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-might-also-like"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('you-might-also-like')) {
    /**
     * Fills the "You might also like" section: related products of the seed product first, then best sellers.
     * Candidates are rendered by this same section through the Section Rendering API.
     */
    class YouMightAlsoLike extends HTMLElement {
      #observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0]?.isIntersecting) return;
          observer.disconnect();
          this.#load();
        },
        { rootMargin: '0px 0px 600px 0px' }
      );

      connectedCallback() {
        // Only the shell loads products; candidate lists are parsed, never connected
        if (!this.dataset.sectionId) return;

        // A hidden element never intersects, so watch the marker rendered next to it instead
        const marker = document.querySelector(`[data-ymal-marker="${this.id}"]`);
        this.#observer.observe(marker ?? this.parentElement ?? this);
      }

      disconnectedCallback() {
        this.#observer.disconnect();
      }

      async #load() {
        const { sectionId, seedProductId, currentProductId, currentCollection, relatedUrl, bestSellersUrl } =
          this.dataset;
        const list = this.querySelector('[data-ymal-list]');
        const max = Number(this.dataset.maxProducts) || 4;
        if (!list || !sectionId) return;

        /** @type {Element[]} */
        const picked = [];
        const seen = new Set([currentProductId]);

        // Capped collections list the ids they display; those are skipped instead of the whole collection
        const displayedIds = (this.dataset.displayedProductIds ?? '').split(',').filter(Boolean);
        for (const id of displayedIds) seen.add(id);
        const skipCollection = displayedIds.length ? '' : currentCollection;

        /**
         * @param {Element[]} items
         * @param {boolean} allowCurrentCollection
         */
        const take = (items, allowCurrentCollection) => {
          for (const item of items) {
            if (picked.length >= max) return;
            if (!(item instanceof HTMLElement)) continue;

            const id = item.dataset.productId;
            if (!id || seen.has(id)) continue;
            if (!allowCurrentCollection && skipCollection && item.dataset.collections?.includes(`|${skipCollection}|`)) {
              continue;
            }

            seen.add(id);
            picked.push(item);
          }
        };

        // Collection pages need spare candidates, because products of the current collection are skipped
        const limit = currentCollection ? 10 : max + 2;
        // An empty collection has no seed product: skip straight to best sellers
        const related = seedProductId
          ? await this.#fetchItems(
              `${relatedUrl}?section_id=${sectionId}&product_id=${seedProductId}&limit=${limit}&intent=related`
            )
          : [];
        take(related, false);

        if (picked.length < max && bestSellersUrl) {
          take(await this.#fetchItems(`${bestSellersUrl}&section_id=${sectionId}`), false);
        }

        // Last resort: related products that are also in the collection being viewed
        if (picked.length < max) take(related, true);

        if (!picked.length) return;

        list.replaceChildren(...picked.map((item) => document.importNode(item, true)));
        this.hidden = false;
      }

      /**
       * @param {string} url
       * @returns {Promise<Element[]>} The candidate product cards rendered by this section
       */
      async #fetchItems(url) {
        try {
          const response = await fetch(url);
          if (!response.ok) return [];

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          return Array.from(html.querySelectorAll(`you-might-also-like[id="${this.id}"] [data-ymal-item]`));
        } catch (error) {
          console.error(error);
          return [];
        }
      }
    }

    customElements.define('you-might-also-like', YouMightAlsoLike);
  }

  } catch(e) { console.error(e); }
})();
})();
